import { orderBy } from 'lodash';
import { filterUnique } from 'lib/filter';
import { SortDirection } from 'types/sort';

// Map of source and target sort direction sequences
const sortSequenceMap = new Map<Optional<SortDirection>, Optional<SortDirection>>([
  [undefined, 'asc'],
  ['asc', 'desc'],
  ['desc', undefined],
]);

/**
 * Get sort direction following the specified one
 *
 * @param {SortDirection} current Current sort direction
 */
export const getNextSortDirection = (current?: SortDirection) => sortSequenceMap.get(current);

/**
 * Sort entities by one of the fields in the specified direction
 *
 * @param {Array} entities Source entities
 * @param {string} sortKey Entity field name to sort by
 * @param {SortDirection} sortDir Sort direction
 * @param {Array<string>} secondaryFields Other fields to sort by after the main one
 */
export const getSortedEntityList = <TEntity>(
  entities: Array<TEntity>,
  sortKey?: string,
  sortDir: SortDirection = 'asc',
  secondaryFields: Array<keyof TEntity> = [],
) => {
  // Skip sorting if no sort fields are specified
  if (!sortKey && !secondaryFields.length) {
    return entities;
  }

  // Sort entities using the primary field first followed by any optional secondary fields
  const fields = filterUnique([sortKey] as Array<keyof TEntity>, secondaryFields);
  return orderBy(entities, fields, [sortDir]);
};
